import { makeStyles } from "@material-ui/core/styles";
import { CgProfile, CgFeed } from "react-icons/cg";
import { IoLocationSharp } from "react-icons/io5";
import { useLocation } from "@reach/router";
import { Paper, Tab, Tabs } from "@material-ui/core";
import { navigate } from "@reach/router";
import ErrorPage from "./ErrorPage/ErrorPage";

const useStyles = makeStyles((theme) => ({
  appBar: {
    top: "auto",
    bottom: 0,
    backgroundColor: theme.palette.contrastThreshold,
    position: "fixed",
    width: "100%",
  },
  icon: { margin: "10px 0" },
}));

function AppBar() {
  const handleChange = (event, newValue) => {
    switch (newValue) {
      case 0:
        navigate("/feed");
        break;
      case 1:
        navigate("/stationen");
        break;
      case 2:
        navigate("/profile");
        break;
      default:
        return <ErrorPage />;
    }
  };

  const location = useLocation();
  const classes = useStyles();
  let page = 0;

  if ("/create-account" === location.pathname) {
    page = 1;
    return null;
  } else if ("/sign-in" === location.pathname) {
    page = 1;
    return null;
  } else if ("/" === location.pathname) {
    page = 1;
    return null;
  }

  if (location.pathname.match("/feed") || location.pathname.match("/mitteilung")) {
    page = 0;
  }
  if (location.pathname.match("/stationen")) {
    page = 1;
  }
  if (
    location.pathname.match("/profile") ||
    location.pathname.match("/settings") ||
    location.pathname.match("/statistik") ||
    location.pathname.match("/privacy") ||
    location.pathname.match("/erfolge") ||
    location.pathname.match("/accessibility") ||
    location.pathname.match("/impressum") ||
    location.pathname.match("/follow")
  ) {
    page = 2;
  }

  return (
    <Paper square className={classes.appBar}>
      <Tabs
        value={page}
        onChange={handleChange}
        variant="fullWidth"
        indicatorColor="primary"
        textColor="primary"
        aria-label="navbar"
      >
        <Tab
          alt="Übungsfeed"
          icon={<CgFeed size="24px" className={classes.icon} />}
          aria-label="Feed"
        />
        <Tab
          alt="Stationsübersicht"
          icon={<IoLocationSharp size="24px" className={classes.icon} />}
          aria-label="Stationen"
        />
        <Tab
          alt="Profil"
          icon={<CgProfile size="24px" className={classes.icon} />}
          aria-label="Profil"
        />
      </Tabs>
    </Paper>
  );
}

export default AppBar;
